export default __webpack_public_path__ + "static/media/tiff.fe2e22f6.svg";